// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"c99dbfa7","314":"3b31cd45","686":"843ba020"}[chunkId] + ".chunk.js";
};